module.exports = __webpack_public_path__ + "static/img/a100.be64b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a100.jpg
// module id = HLd9
// module chunks = 0